<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Crack Status Management</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
     
     
      <div class="input-container">
          <span class="label">Component</span>
          <input type="text"  min="0" [(ngModel)]="compName"  [disabled]="true" style="height: 40px;display: inline !important; background-color: #F4F7FA;
          color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;"> 
      </div>

      <div class="input-container">
        <span class="label">Observation Point</span>
        <input type="text"  min="0" [(ngModel)]="ObsName"  [disabled]="true" style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;"> 
    </div>

      <div class="input-container" *ngIf="showSMU">
          <span class="label">SMU</span>
          <input type="number"  min="0" [(ngModel)]="currentSmu"     step="any" style="height: 40px;display: inline !important; background-color: #F4F7FA;
          color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;"> 
      </div>
      
      <div class="input-container">
          <span class="label">Date</span>
          <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()"  style="padding: 7px 16px;
          background: #E4EAF0;
          font-size: 14px;">
              <i class="material-icons">date_range</i>
          </span>
          <input type="text" [matDatepicker]="picker" class="get-Input-date"
                 [max]="maxDateForAction" placeholder="Choose a date" [min]="minDate"
                 [(ngModel)]="eventDate" (ngModelChange)="dateChanged()"
                 readonly="readonly" style="color: black">
          <mat-datepicker #picker></mat-datepicker>
      </div>

      <!-- <div class="input-container">
        <span class="label">Status</span>
        <select (change)="ChangeObsStatus($event.target.value)" style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;" [(ngModel)]="crackstatus" >
            <option value="1">Fixed</option>
            <option value="2">Un-Repaired</option>
        </select>
       
    </div> -->
    <div class="input-container">
        <span class="label">Status</span>
        <select (change)="ChangeObsStatus($event.target.value)" style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;" [(ngModel)]="crackstatus">
                    <option [value]="cr.Id" *ngFor="let cr of CrackStatuses">
                      {{cr.CrackStatus}}
                    </option>
                  </select>
       
    </div>
    <div class="input-container" *ngIf="crackstatus==1">
        <span class="label">Cost</span>
        <input type="number"  min="0" [(ngModel)]="cost"   style="height: 40px;display: inline !important; background-color: #F4F7FA;
        color: #1D2F36; min-height: 40px; padding: 10px; min-width: 300px;"> 
    </div>

      <div style="margin-bottom: 16px;margin-left: 8px;">Comment</div>
      <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()" class="textAreaComment">
                </textarea>
  </div>
  <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <button class="button button--primary"  [disabled]="savingChanges" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></button>
  </div>
</div>